import { GridColDef } from "@mui/x-data-grid";

const entityPermissionsColDef: GridColDef[] = [
    { field: 'entity_type', headerName: 'Entity Type', width: 150 },
    { field: 'entity_name', headerName: 'Entity Name', width: 150 },
    { field: 'permission_name', headerName: 'Permission Name', width: 150 },
    { field: 'is_permission_granted', headerName: 'Permission Granted Status', width: 200 },
    { field: 'license_count', headerName: 'License Count', width: 150 },
    { field: 'created_date', headerName: 'Created Date', width: 150 },
    { field: 'created_by', headerName: 'Created By', width: 150 },
    { field: 'updated_date', headerName: 'Update Date', width: 150 },
    { field: 'updated_by', headerName: 'Updated By', width: 150 },
];

export default entityPermissionsColDef;